export class Utils {
    static basename(filename: string) {
        let base = filename.substring(filename.lastIndexOf('/') + 1);
        if(base.lastIndexOf(".") != -1) base = base.substring(0, base.lastIndexOf("."));
        return base;
    }
    static extension(filename: string) {
        return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2)
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/utils.ts